module.exports = __webpack_public_path__ + "img/ic-hand-waving.7d5a053a.svg";